/**
 * @VIP模块
 * 2023-06-19 kadiam
*/
// import bossApi from '../utils/bossApi'
import bossWholesale from '../utils/wholesaleRequest'

// 用户中心-会员信息
export function apiWholesaleVip_member() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/member', method: 'get' })
}
// 首页弹窗
export function apiWholesaleVip_homePop() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/homePop', method: 'get' })
}
// VIP领取
export function apiWholesaleVip_receiveVip() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/receiveVip', method: 'get' })
}
// VIP倒计天数提示
export function apiWholesaleVip_vipPopUpDowngrading() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/vipPopUpDowngrading', method: 'get' })
}
// VIP倒计天数提示
export function levelList() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/levelList', method: 'get' })
}
// VIP倒计天数提示
export function memberCenter() {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleVip/memberCenter', method: 'get' })
}
